// extracted by mini-css-extract-plugin
export default {"card":"CourseCardBase_card__lHK3s","disabled":"CourseCardBase_disabled__lrs8B","disabledOverlay":"CourseCardBase_disabledOverlay__Z+g53"};